import request from "@/utils/request";

export default function agentGetBindWeChatPUshSCode() {
    return request({
        url: `/user/agent/agentGetBindWeChatPUshSCode`,
    })
}